export default "__VITE_ASSET__rO$jgudc__"